type TNetworkInformation = {
    rtt?: number
    downlink?: number
    effectiveType?: string
    saveData?: boolean
    type?: string
}

export type TNetworkInfo = {
    network_rtt: number
    network_downlink: number
    network_effective_type: string
    network_type: string
    network_save_data: boolean
}

const KBIT_IN_MBIT = 1000

export const getNetworkInfo = (): TNetworkInfo => {
    const { connection } = navigator as Navigator & { connection?: TNetworkInformation }

    return {
        network_rtt: connection?.rtt ?? 0,
        network_downlink: Math.round((connection?.downlink ?? 0) * KBIT_IN_MBIT),
        network_effective_type: connection?.effectiveType ?? 'unsupported',
        network_type: connection?.type ?? '',
        network_save_data: connection?.saveData ?? false,
    }
}
